/**
 * Named color palettes for tenant theming
 *
 * Each palette defines primary and secondary color scales (1-10)
 * where shade 6 is the main brand color.
 */

export interface IColorPalette {
  1: string;
  2: string;
  3: string;
  4: string;
  5: string;
  6: string; // Main brand color
  7: string;
  8: string;
  9: string;
  10: string;
}

export interface ITenantThemeConfig {
  primary: IColorPalette;
  secondary: IColorPalette;
}

/** Board Infinity brand colors — blue primary + orange secondary */
export const DEFAULT_PALETTE: ITenantThemeConfig = {
  primary: {
    1: "#E6F7FF",
    2: "#A3DDFF",
    3: "#74C0F2",
    4: "#49A2E6",
    5: "#2384D9",
    6: "#0066CC",
    7: "#004DA6",
    8: "#003780",
    9: "#002459",
    10: "#001333"
  },
  secondary: {
    1: "#FFFAE6",
    2: "#FFEBA8",
    3: "#FFDD80",
    4: "#FFCD57",
    5: "#FFB92E",
    6: "#FCA106",
    7: "#D68100",
    8: "#B06400",
    9: "#8A4900",
    10: "#633200"
  }
};

/** Dark red primary + cyan secondary */
export const PALETTE_VIOLLET: ITenantThemeConfig = {
  primary: {
    1: "#F5F3FF",
    2: "#EDE9FE",
    3: "#DDD6FE",
    4: "#C4B5FD",
    5: "#7E55F6",
    6: "#7C3AED",
    7: "#6D28D9",
    8: "#5B21B6",
    9: "#4C1D95",
    10: "#2E1065"
  },
  secondary: {
    1: "#FFFAE6",
    2: "#FFEBA8",
    3: "#FFDD80",
    4: "#FFCD57",
    5: "#FFB92E",
    6: "#FCA106",
    7: "#D68100",
    8: "#B06400",
    9: "#8A4900",
    10: "#633200"
  }
};

/** Purple/violet primary + coral secondary */
export const PALETTE_TEAL: ITenantThemeConfig = {
  primary: {
    1: "#ECFEFF",
    2: "#CFFAFE",
    3: "#A5F3FC",
    4: "#67E8F9",
    5: "#0EB3DB",
    6: "#0891B2",
    7: "#0E7490",
    8: "#155E75",
    9: "#164E63",
    10: "#083344"
  },
  secondary: {
    1: "#FFFAE6",
    2: "#FFEBA8",
    3: "#FFDD80",
    4: "#FFCD57",
    5: "#FFB92E",
    6: "#FCA106",
    7: "#D68100",
    8: "#B06400",
    9: "#8A4900",
    10: "#633200"
  }
};

export const PALETTE_AMBER: ITenantThemeConfig = {
  primary: {
    1: "#FFFBEB",
    2: "#FEF3C7",
    3: "#FDE68A",
    4: "#FCD34D",
    5: "#EF870F",
    6: "#D97706",
    7: "#B45309",
    8: "#92400E",
    9: "#78350F",
    10: "#451A03"
  },
  secondary: {
    1: "#ECEEF8",
    2: "#D9DCF1",
    3: "#B3BAE3",
    4: "#8D97D5",
    5: "#6675C8",
    6: "#3949AB",
    7: "#2D3A89",
    8: "#212B67",
    9: "#161D45",
    10: "#0B0E23"
  }
};
